const GLN_PATTERN = /^\d{13}$/;

/**
 * A GLN (Global Location Number) is exactly 13 digits closed by a GS1 mod-10 check digit.
 *
 * Whitespace is rejected rather than stripped, mirroring the backend rule
 * (`Support\Rules\Gs1Identifier` in procuros-mvp, whose pattern is `/^\d{13}$/`). Callers
 * trim before validating and submit the trimmed value, so the two sides never disagree
 * about what was checked.
 *
 * This deliberately rejects valid GTIN-8/12/14 values: they share the check-digit scheme
 * but are never valid GLNs, which is why `@procuros/datachecks`' `isValidGtin` cannot be
 * reused here.
 */
export const isValidGln = (value: string | null | undefined): boolean => {
  if (!value || !GLN_PATTERN.test(value)) {
    return false;
  }

  let sum = 0;
  for (let index = 0; index < 12; index++) {
    sum += Number(value[index]) * (index % 2 === 0 ? 1 : 3);
  }

  return (10 - (sum % 10)) % 10 === Number(value[12]);
};
